import React, { useContext, useEffect, useRef } from 'react';
import { View } from 'react-native';

import AuthContext from 'app/src/contexts/AuthContext';
import { Text } from 'app/src/styles';
import { rest } from 'app/src/utils/rest';

const PrintCheck = ({ txn, setShowModal }) => {
  const { credentials } = useContext(AuthContext);
  const iframeRef = useRef();

  const setupIframe = blob => {
    const dataUrl = window.URL.createObjectURL(blob);
    iframeRef.current.setAttribute('src', dataUrl);
  };

  const preview = () => {
    let path = `accounting/check/${txn.id}.pdf`;

    rest({
      path,
      options: { headers: { Accept: 'application/pdf' } },
      credentials,
    }).then(response => {
      response.blob().then(blob => setupIframe(blob));
    });
  };

  useEffect(() => {
    if (txn) { preview(); }
  }, [txn]);

  return (
    <View style={{ minWidth: '70vw' }}>
      <iframe ref={iframeRef} width="100%" height="400px"></iframe>
    </View>
  );
};

export default PrintCheck;
